import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./Wast.css"
function Wast (){
    return(
        <div className="our-wast">
            <div className="container">
                <div className="wast-content">
                    <h3>Baked fresh daily by bakers with passion.</h3>
                    <button className="more">learn more</button>
                </div>
            </div>
        </div>
    )
}
export default Wast